@if (
  {
    primary: primaryBorrower$ | async,
    additional: additionalBorrower$ | async,
    property: propertyData$ | async,
    loan: loanInfo$ | async,
  };
  as vm
) {
  <div class="row">
    <div class="col-md-6 mb-3">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Borrower Information</ng-template>
        <cmg-info-panel-content>
          <cmg-info-row label="Borrower Name" [value]="vm.primary?.firstName + ' ' + vm.primary?.lastName" />
          <cmg-info-row label="Borrower SSN" [value]="(vm.primary?.ssn | ssn | emptyToDash) || '-'" />
          <cmg-info-row label="Additional Borrower Name" [value]="(vm.additional?.firstName || 'NA') + ' ' + (vm.additional?.lastName || '')" />
          <cmg-info-row label="Additional Borrower SSN" [value]="vm.additional?.ssn ? (vm.additional.ssn | ssn) : 'NA'" />
        </cmg-info-panel-content>
      </p-panel>
    </div>
    <div class="col-md-6 mb-3">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Property Information</ng-template>
        <cmg-info-panel-content>
          <cmg-info-row
            label="Property Address"
            [value]="propertyFullAddress(vm.property?.street, vm.property?.city, vm.property?.state, vm.property?.zip)"
          />
          <cmg-info-row label="Property Type" [value]="vm.property?.propertyType | toNameOrValueNoSelect: subjectPropertyTypes : 'name'" />
          <cmg-info-row label="Occupancy Type" [value]="fileData?.occupancyType | toNameOrValueNoSelect: occupancyTypes : 'name'" />
          <cmg-info-row label="Project Name" [value]="vm.property?.projectName | emptyToDash" />
          <cmg-info-row
            label="Project Classification"
            [value]="vm.property?.projectClassification | toNameOrValueNoSelect: projectClassifications : 'name'"
          />
          <cmg-info-row label="CPM Project ID" [value]="loan1008Data?.cpmProjectID | emptyToDash" />
        </cmg-info-panel-content>
      </p-panel>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-panel class="secondary-panel">
        <ng-template pTemplate="header">Additional Property Information</ng-template>
        <cmg-info-panel-content>
          <div class="row">
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="Number of Units" [value]="vm.property?.numberOfUnits | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row label="Sales Price" [value]="vm.loan?.salesPrice | currency | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 border-md-end">
              <cmg-info-row label="Appr. Value" [value]="vm.loan?.appraisalValue | currency | emptyToDash" />
            </div>
            <div class="col-12 col-md-6 ps-md-4">
              <cmg-info-row label="Property Rights" [value]="vm.property?.estate | toNameOrValueNoSelect: estateTypes : 'name'" />
            </div>
          </div>
        </cmg-info-panel-content>
      </p-panel>
    </div>
  </div>
}
